/* @ts-self-types="./stereo_wasm.d.ts" */

/**
 * A depth map returned to JS.
 */
export class DepthOut {
    static __wrap(ptr) {
        const obj = Object.create(DepthOut.prototype);
        obj.__wbg_ptr = ptr;
        DepthOutFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DepthOutFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_depthout_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get height() {
        const ret = wasm.depthout_height(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * Moves the samples out (a `Float32Array`).
     * @returns {Float32Array}
     */
    takeData() {
        const ret = wasm.depthout_takeData(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    get width() {
        const ret = wasm.depthout_width(this.__wbg_ptr);
        return ret >>> 0;
    }
}
if (Symbol.dispose) DepthOut.prototype[Symbol.dispose] = DepthOut.prototype.free;

/**
 * Streaming animated GIF encoder with a global palette.
 */
export class GifEncoder {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GifEncoderFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_gifencoder_free(ptr, 0);
    }
    /**
     * @param {Uint8Array} rgba
     */
    addFrame(rgba) {
        const ptr0 = passArray8ToWasm0(rgba, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.gifencoder_addFrame(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {Uint8Array}
     */
    finish() {
        const ret = wasm.gifencoder_finish(this.__wbg_ptr);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @param {number} w
     * @param {number} h
     * @param {number} fps
     * @param {boolean} repeat
     */
    constructor(w, h, fps, repeat) {
        const ret = wasm.gifencoder_new(w, h, fps, repeat);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0];
        GifEncoderFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Samples a frame for the palette (call before the first `addFrame`).
     * @param {Uint8Array} rgba
     */
    train(rgba) {
        const ptr0 = passArray8ToWasm0(rgba, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.gifencoder_train(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
}
if (Symbol.dispose) GifEncoder.prototype[Symbol.dispose] = GifEncoder.prototype.free;

/**
 * Streaming temporal filter over depth frames.
 */
export class TemporalSmoother {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TemporalSmootherFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_temporalsmoother_free(ptr, 0);
    }
    /**
     * After the last push: returns remaining frames one by one, then `undefined`.
     * @returns {DepthOut | undefined}
     */
    flushNext() {
        const ret = wasm.temporalsmoother_flushNext(this.__wbg_ptr);
        return ret === 0 ? undefined : DepthOut.__wrap(ret);
    }
    /**
     * @param {string} filter_json
     */
    constructor(filter_json) {
        const ptr0 = passStringToWasm0(filter_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.temporalsmoother_new(ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0];
        TemporalSmootherFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Pushes a frame; returns a filtered frame when one is ready.
     * @param {Float32Array} depth
     * @param {number} w
     * @param {number} h
     * @returns {DepthOut | undefined}
     */
    push(depth, w, h) {
        const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.temporalsmoother_push(this.__wbg_ptr, ptr0, len0, w, h);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] === 0 ? undefined : DepthOut.__wrap(ret[0]);
    }
}
if (Symbol.dispose) TemporalSmoother.prototype[Symbol.dispose] = TemporalSmoother.prototype.free;

/**
 * Applies a procedural animation at loop phase `t` (0..1) on top of `depth`.
 * @param {Float32Array} depth
 * @param {number} w
 * @param {number} h
 * @param {string} anim_json
 * @param {number} t
 * @returns {Float32Array}
 */
export function applyProcedural(depth, w, h, anim_json, t) {
    const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(anim_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.applyProcedural(ptr0, len0, w, h, ptr1, len1, t);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v3 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v3;
}

/**
 * Decodes a PNG (8/16-bit, any colour type) into a depth map (luma, white = near).
 * @param {Uint8Array} bytes
 * @returns {DepthOut}
 */
export function decodeDepthPng(bytes) {
    const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.decodeDepthPng(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return DepthOut.__wrap(ret[0]);
}

/**
 * Derives depth from an RGBA image with a non-ML heuristic.
 * @param {Uint8Array} rgba
 * @param {number} w
 * @param {number} h
 * @param {string} heuristic_json
 * @returns {DepthOut}
 */
export function depthFromImage(rgba, w, h, heuristic_json) {
    const ptr0 = passArray8ToWasm0(rgba, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(heuristic_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.depthFromImage(ptr0, len0, w, h, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return DepthOut.__wrap(ret[0]);
}

/**
 * Encodes a depth map as a 16-bit grayscale PNG.
 * @param {Float32Array} depth
 * @param {number} w
 * @param {number} h
 * @returns {Uint8Array}
 */
export function encodeDepthPng16(depth, w, h) {
    const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.encodeDepthPng16(ptr0, len0, w, h);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v2;
}

/**
 * Encodes RGBA8 pixels as PNG.
 * @param {Uint8Array} rgba
 * @param {number} w
 * @param {number} h
 * @returns {Uint8Array}
 */
export function encodePng(rgba, w, h) {
    const ptr0 = passArray8ToWasm0(rgba, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.encodePng(ptr0, len0, w, h);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v2;
}

/**
 * Evaluates the timeline at `t`: `{camera, local: {id: transform}, visible: {id: bool}}`.
 * @param {string} scene_json
 * @param {number} t
 * @returns {string}
 */
export function evaluateScene(scene_json, t) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(scene_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.evaluateScene(ptr0, len0, t);
        var ptr2 = ret[0];
        var len2 = ret[1];
        if (ret[3]) {
            ptr2 = 0; len2 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred3_0 = ptr2;
        deferred3_1 = len2;
        return getStringFromWasm0(ptr2, len2);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

/**
 * Cross-fade between two depth maps.
 * @param {Float32Array} a
 * @param {Float32Array} b
 * @param {number} w
 * @param {number} h
 * @param {number} t
 * @returns {Float32Array}
 */
export function morphDepth(a, b, w, h, t) {
    const ptr0 = passArrayF32ToWasm0(a, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(b, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.morphDepth(ptr0, len0, ptr1, len1, w, h, t);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v3 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v3;
}

/**
 * Applies a JSON array of `DepthOp`s.
 * @param {Float32Array} depth
 * @param {number} w
 * @param {number} h
 * @param {string} ops_json
 * @returns {DepthOut}
 */
export function processDepth(depth, w, h, ops_json) {
    const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(ops_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.processDepth(ptr0, len0, w, h, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return DepthOut.__wrap(ret[0]);
}

/**
 * Renders one animation frame: applies `ops` to the depth, derives per-frame
 * stereo params from `motion` (static / boiling / scroll) and renders.
 * @param {Float32Array} depth
 * @param {number} w
 * @param {number} h
 * @param {string} ops_json
 * @param {string} params_json
 * @param {string} texture_json
 * @param {string} motion_json
 * @param {number} frame
 * @param {Uint8Array | null | undefined} texture_pixels
 * @param {number} texture_w
 * @param {number} texture_h
 * @returns {Uint8Array}
 */
export function renderAnimationFrame(depth, w, h, ops_json, params_json, texture_json, motion_json, frame, texture_pixels, texture_w, texture_h) {
    const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(ops_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(params_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passStringToWasm0(texture_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passStringToWasm0(motion_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len4 = WASM_VECTOR_LEN;
    var ptr5 = isLikeNone(texture_pixels) ? 0 : passArray8ToWasm0(texture_pixels, wasm.__wbindgen_malloc);
    var len5 = WASM_VECTOR_LEN;
    const ret = wasm.renderAnimationFrame(ptr0, len0, w, h, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, frame, ptr5, len5, texture_w, texture_h);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v7 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v7;
}

/**
 * Reference software render of a scene's depth (same code as the server).
 * @param {string} scene_json
 * @param {number} t
 * @param {number} w
 * @param {number} h
 * @param {number} supersample
 * @returns {DepthOut}
 */
export function renderSceneDepth(scene_json, t, w, h, supersample) {
    const ptr0 = passStringToWasm0(scene_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.renderSceneDepth(ptr0, len0, t, w, h, supersample);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return DepthOut.__wrap(ret[0]);
}

/**
 * Renders a stereogram. `texture_pixels` (RGBA8) is needed for `image` and
 * `source` textures. Returns RGBA8 pixels of size `w * h * 4`.
 * @param {Float32Array} depth
 * @param {number} w
 * @param {number} h
 * @param {string} params_json
 * @param {string} texture_json
 * @param {Uint8Array | null | undefined} texture_pixels
 * @param {number} texture_w
 * @param {number} texture_h
 * @returns {Uint8Array}
 */
export function renderStereogram(depth, w, h, params_json, texture_json, texture_pixels, texture_w, texture_h) {
    const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(params_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(texture_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    var ptr3 = isLikeNone(texture_pixels) ? 0 : passArray8ToWasm0(texture_pixels, wasm.__wbindgen_malloc);
    var len3 = WASM_VECTOR_LEN;
    const ret = wasm.renderStereogram(ptr0, len0, w, h, ptr1, len1, ptr2, len2, ptr3, len3, texture_w, texture_h);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v5 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v5;
}

/**
 * Renders a texture tile preview (RGBA8).
 * @param {string} texture_json
 * @param {number} w
 * @param {number} h
 * @param {bigint} seed
 * @param {Uint8Array | null | undefined} texture_pixels
 * @param {number} texture_w
 * @param {number} texture_h
 * @returns {Uint8Array}
 */
export function renderTexture(texture_json, w, h, seed, texture_pixels, texture_w, texture_h) {
    const ptr0 = passStringToWasm0(texture_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(texture_pixels) ? 0 : passArray8ToWasm0(texture_pixels, wasm.__wbindgen_malloc);
    var len1 = WASM_VECTOR_LEN;
    const ret = wasm.renderTexture(ptr0, len0, w, h, seed, ptr1, len1, texture_w, texture_h);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v3 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v3;
}

/**
 * Local-space triangle soup for a shape (`Shape` JSON; not for mesh shapes).
 * @param {string} shape_json
 * @returns {Float32Array}
 */
export function shapeTriangles(shape_json) {
    const ptr0 = passStringToWasm0(shape_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.shapeTriangles(ptr0, len0);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * @returns {string}
 */
export function version() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.version();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}
function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg_Error_30c8987f7c2ed4e2: function(arg0, arg1) {
            const ret = Error(getStringFromWasm0(arg0, arg1));
            return ret;
        },
        __wbg___wbindgen_throw_41e9ee4f547fc59a: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbindgen_init_externref_table: function() {
            const table = wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        },
    };
    return {
        __proto__: null,
        "./stereo_wasm_bg.js": import0,
    };
}

const DepthOutFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_depthout_free(ptr, 1));
const GifEncoderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_gifencoder_free(ptr, 1));
const TemporalSmootherFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_temporalsmoother_free(ptr, 1));

function getArrayF32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedFloat32ArrayMemory0 = null;
function getFloat32ArrayMemory0() {
    if (cachedFloat32ArrayMemory0 === null || cachedFloat32ArrayMemory0.byteLength === 0) {
        cachedFloat32ArrayMemory0 = new Float32Array(wasm.memory.buffer);
    }
    return cachedFloat32ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    return decodeText(ptr >>> 0, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArrayF32ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 4, 4) >>> 0;
    getFloat32ArrayMemory0().set(arg, ptr / 4);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasmInstance, wasm;
function __wbg_finalize_init(instance, module) {
    wasmInstance = instance;
    wasm = instance.exports;
    wasmModule = module;
    cachedFloat32ArrayMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    wasm.__wbindgen_start();
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (!module.ok) {
            throw new Error(`failed to fetch Wasm: ${module.status} ${module.statusText} fetching '${module.url}'`);
        }

        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('stereo_wasm_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
